module.exports = __webpack_public_path__ + "img/yalda_afsaka_yes.eaa0c1f9.png";